'use client';
import { Button } from '@pickleballinc/react-ui';
import { useEffect, useState } from 'react';

import { getLoginUrl } from '@/utils/helpers/getLoginUrl';

interface PlayersLoginCardProps {
  className?: string;
}

export const PlayersLoginCard = ({ className }: PlayersLoginCardProps) => {
  const [baseURL, setBaseURL] = useState('');

  useEffect(() => {
    setBaseURL(window.location.href);
  }, []);
  return (
    <div
      className={`player-login-card w-[268px] flex-col items-center rounded-lg bg-experiment py-4 ${className ? className : ''}`}
    >
      <div className='px-1 text-center text-sm text-white'>
        Login or Sign Up to view Amateur data of more than 500,000 Pickleball Players
      </div>
      <div className='flex justify-center pt-3'>
        <a href={getLoginUrl(baseURL)} rel='nofollow' aria-label='Link to login or sign up'>
          <Button variant='secondary' size='sm' className='bg-white'>
            Login or Sign Up
          </Button>
        </a>
      </div>
    </div>
  );
};
